import React from 'react';
import { DateTime } from 'luxon';
import { getFullDateString } from '~/utils/date';

export interface DateFullDescriptionProps {
  datetime: DateTime;
  className?: string;
}

export default function DateFullDescription({
  datetime,
  className,
}: DateFullDescriptionProps) {
  const formattedDate = getFullDateString(datetime);

  return (
    <div
      className={
        className ??
        'rounded bg-neutral-200 font-bold m-2 py-2 px-3 text-lg text-center'
      }
    >
      Your message will be sent on {formattedDate}
    </div>
  );
}
